const predicate =
  (pinnedSegmentIds: string[]) =>
  (itinerary): boolean => {
    if (!pinnedSegmentIds || pinnedSegmentIds?.length === 0) return true;

    const itinerarySegmentIds: string[] = itinerary.legs.flatMap((leg) =>
      leg.segments.map((segment) => segment.id)
    );
    return pinnedSegmentIds?.every((segmentId) =>
      itinerarySegmentIds.includes(segmentId)
    );
  };

export default predicate;
